import { HttpErrorResponse, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';
import { CompanyContextService } from './company-context.service';

const NO_RETRY = ['/auth/login', '/auth/refresh', '/auth/microsoft/exchange', '/auth/logout'];

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiUrl)) return next(req);

  const auth = inject(AuthService);
  const context = inject(CompanyContextService);

  const withHeaders = (request: HttpRequest<unknown>, token: string | null) => {
    let headers = request.headers.set('Accept', 'application/json');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    const companyId = context.adminCompanyId();
    if (companyId) headers = headers.set('X-Company-Id', String(companyId));
    return request.clone({ headers });
  };

  return next(withHeaders(req, auth.token())).pipe(
    catchError((err: unknown) => {
      const canRetry = err instanceof HttpErrorResponse && err.status === 401 && auth.token() && !NO_RETRY.some((p) => req.url.includes(p));
      if (!canRetry) return throwError(() => err);

      return auth.refresh().pipe(
        catchError((refreshErr) => {
          auth.expire();
          return throwError(() => refreshErr);
        }),
        switchMap((token) => next(withHeaders(req, token))),
      );
    }),
  );
};
